var _circle, _circle2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefitDetailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0px)",
      clipPath: "url(#bgblur_0_9400_517_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 0,
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "url(#paint0_linear_9400_517)",
    fillOpacity: 0.24
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0px)",
      clipPath: "url(#bgblur_1_9400_517_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 0,
    cx: 24.5,
    cy: 24.5,
    r: 18.5,
    fill: "url(#paint1_linear_9400_517)",
    fillOpacity: 0.24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_9400_517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0453 31.4993C26.0453 31.6875 25.8927 31.8401 25.7044 31.8401H23.3183C23.1301 31.8401 22.9774 31.6875 22.9774 31.4993V26.7271C22.9774 26.4647 23.2615 26.3007 23.4888 26.4319C23.5942 26.4928 23.6592 26.6053 23.6592 26.7271V31.1584H25.7044C25.8927 31.1584 26.0453 31.311 26.0453 31.4993ZM20.7891 26.4502C20.6361 26.3406 20.4232 26.3756 20.3136 26.5286L18.887 28.5269L17.4596 26.5286C17.3018 26.3189 16.9763 26.3587 16.8736 26.6001C16.8281 26.707 16.8402 26.8297 16.9057 26.9257L18.4677 29.1132L16.9057 31.3007C16.7963 31.4539 16.8318 31.6668 16.985 31.7762C17.0424 31.8181 17.1116 31.8405 17.1827 31.8401C17.2925 31.8401 17.3956 31.7871 17.4596 31.6978L18.887 29.6995L20.3136 31.6978C20.3777 31.7874 20.4812 31.8404 20.5914 31.8401C20.6624 31.8405 20.7317 31.8181 20.7891 31.7762C20.9423 31.6668 20.9777 31.4539 20.8683 31.3007L19.3054 29.1132L20.8683 26.9257C20.9777 26.7725 20.9423 26.5596 20.7891 26.4502ZM29.3253 28.6999C28.4279 28.4442 28.0402 28.2815 28.0956 27.8409C28.1116 27.6173 28.2294 27.4134 28.4152 27.2878C28.9486 26.9274 30.0147 27.097 30.3811 27.1932C30.6375 27.2492 30.8583 27.0066 30.7786 26.7566C30.7444 26.6494 30.6594 26.5659 30.5516 26.5337C30.2584 26.4622 29.9596 26.4163 29.6585 26.3965C28.9674 26.3505 28.4194 26.4604 28.0317 26.722C27.6833 26.9581 27.4578 27.3369 27.4164 27.7557C27.2809 28.8201 28.3078 29.1192 29.1327 29.3552C30.0914 29.6322 30.5354 29.8231 30.4646 30.3727C30.4478 30.6052 30.3253 30.8172 30.1323 30.9479C29.5971 31.3033 28.5464 31.1226 28.1868 31.0229C27.9368 30.9431 27.6942 31.1637 27.75 31.4201C27.7778 31.548 27.8763 31.6486 28.0036 31.6791C28.3989 31.7829 28.8057 31.837 29.2145 31.8402C29.6551 31.8402 30.1374 31.7669 30.5115 31.5189C30.8695 31.2782 31.1016 30.8905 31.1447 30.4613C31.2972 29.27 30.1579 28.9428 29.3253 28.6999ZM30.4766 21.6141H26.0453C25.857 21.6141 25.7044 21.4615 25.7044 21.2732V16.8419H17.8644C17.6761 16.8419 17.5235 16.9945 17.5235 17.1828V23.3184C17.5235 23.5808 17.2395 23.7448 17.0122 23.6136C16.9068 23.5527 16.8418 23.4402 16.8418 23.3184V17.1828C16.8418 16.618 17.2996 16.1601 17.8644 16.1602H26.0453C26.1357 16.1601 26.2225 16.196 26.2864 16.2599L31.0586 21.032C31.1225 21.096 31.1584 21.1828 31.1583 21.2732V23.3184C31.1583 23.5808 30.8743 23.7448 30.647 23.6136C30.5415 23.5527 30.4766 23.4402 30.4766 23.3184V21.6141ZM29.9951 20.9323L26.3861 17.3234V20.9323H29.9951Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9400_517_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "translate(0 0)",
    cx: 24.5,
    cy: 24.5,
    r: 24.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9400_517_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "translate(0 0)",
    cx: 24.5,
    cy: 24.5,
    r: 18.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9400_517",
    x1: 25.213,
    y1: 8.91922,
    x2: 23.8224,
    y2: 44.1105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5445FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9400_517",
    x1: 25.0384,
    y1: 12.7349,
    x2: 23.9883,
    y2: 39.3079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5445FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_9400_517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitDetailed);
export default __webpack_public_path__ + "res/media/benefit-detailed.b10d9df7453b812399b0c435dbaa7d3f.svg";
export { ForwardRef as ReactComponent };